import { FWNElement } from './bases/FWNElement'

class VideoChatElement extends FWNElement {
  height = '100%'
  width = '100%'

  override render(): void {
    const params = {
      height: this.height,
      width: this.width,
      ...this.getAttributes(),
    }

    import('@embed/videoChatRender').then(({ videoChatRender }) => {
      if (this.shadowRoot) {
        videoChatRender({
          target: this.shadowRoot,
          widgetId: this.widgetId,
          widgetParams: params,
        })
      }
    })
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'fw-video-chat': Record<string, string>
    }
  }
}

if (!customElements.get('fw-video-chat')) {
  customElements.define('fw-video-chat', VideoChatElement)
}
